import useController from '@common/hooks/useController'

// Native shim — match web context shape { state, callProvider, callContract, ... }.
// On RN, controllers live inside WebViewWorker; UI-side direct provider calls
// are stubbed and return rejected/empty.
const noopAsync = () => Promise.reject(new Error('provider call unavailable on native UI'))

export default function useProvidersControllerState(): any {
  const { state } = useController('ProvidersController' as any)
  return {
    state: state || {},
    callProvider: noopAsync,
    callContract: noopAsync
  }
}
